/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { CONTENT_TYPE, MODE } from './constants';
import CustomPopupText from '../shared/CustomPopupText';
import CustomTextField from '../shared/CustomTextField';
import CustomDropDown from '../shared/CustomDropDown';
import CustomUploadField from '../shared/CustomUploadField';
import CustomRadioGroup from '../shared/CustomRadioGroup';
import CustomPicker from '../shared/CustomPicker';
import CustomMultiSelect from '../shared/CustomMultiSelect';
import CustomSwitch from '../shared/CustomSwitch';
import CustomGroupDropDown from '../shared/CustomGroupDropDown';
import { DIMENSIONS } from '../../constants/aspectRatio';
import { VideoLinkInput } from '../../features/vimeo-picker';

const useStyles = makeStyles({
  publishDateField: {
    height: '44px',
    padding: '12px 12px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    marginTop: '12px',
    marginBottom: '12px',
    border: '1px solid rgba(228, 231, 236, 1)',
    borderRadius: '8px',
    background: 'rgba(254, 254, 254, 1)',
    boxSizing: 'border-box',
  },
  container: {
    padding: '20px',
    background: '#f3f4f7',
    height: '78vh',
    overflowY: 'auto',
  },
  swtichContainer: {
    margin: '12px 0px 12px 0px',
  },
});

function CollectionDetail({
  contentType,
  setContentType,
  rnp,
  list,
  catList,
  handleChange,
  data,
  handleMultiSelectChange,
  expList,
  certificateImg,
  thumbnailImg,
  handleImageUploadNew,
  handleThumbnailUpload,
  handleGroupChange,
  selectedCatValues,
  mainArr,
  handleDeleteImage,
  certFileName,
  mode,
}) {
  const classes = useStyles();
  const [options, setOptions] = useState([]);
  const handleContentType = ({ target: { value } }) => {
    setContentType({ type: parseInt(value, 10), selectedItem: '', dueDate: null });
  };
  const handleDateChange = (label, date) => setContentType((pre) => ({ ...pre, [label]: date }));
  useEffect(() => {
    if (parseInt(contentType.type, 10) === 2) {
      setOptions(rnp.OEM || []);
    } else if (parseInt(contentType.type, 10) === 3) {
      setOptions(rnp.PARTNER || []);
    } else {
      setOptions([]);
    }
  }, [contentType.type, rnp]);

  const accessToAllJourney = mode === MODE.add ? data?.accessOnAllJourneys || data?.isEpg : data?.accessOnAllJourneys;

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <CustomPopupText text="Collection Name" required />
        <CustomTextField name="title" handleChange={handleChange} defaultValue={data?.title} width="100%" />
      </Grid>
      <Grid item xs={12}>
        <CustomPopupText text="Tagline" required />
        <CustomTextField name="goal" handleChange={handleChange} defaultValue={data?.goal} width="100%" />
      </Grid>
      <Grid item xs={12}>
        <CustomPopupText text="Description (char limit - 255)" required />
        <CustomTextField
          name="description"
          handleChange={handleChange}
          defaultValue={data?.description}
          width="100%"
          multiline
        />
      </Grid>
      <Grid item xs={12}>
        <CustomPopupText text="Collection Reporting Code" />
        <CustomTextField
          name="courseCode"
          handleChange={handleChange}
          defaultValue={data?.courseCode}
          width="100%"
          multiline
        />
      </Grid>
      <Grid item xs={12}>
        <CustomPopupText text="Thumbnail (max size - 100kb)" required />
        <CustomUploadField
          type="image"
          name="thumbnail"
          imgSrc={thumbnailImg}
          handleChange={handleThumbnailUpload}
          customStyles={{ height: '44px', width: '482px' }}
          dimensions={DIMENSIONS.collection}
        />
      </Grid>
      <Grid item xs={12}>
        <VideoLinkInput
          value={data?.avPreview || ''}
          onChange={(val) => handleChange({ target: { name: 'avPreview', value: val } })}
          label="Collection Preview Video Link"
        />
      </Grid>
      <Grid item xs={12}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={classes.swtichContainer}
        >
          <Grid item>
            <CustomPopupText text="Make collection visible only when all journeys are accessible" />
          </Grid>

          <Grid item>
            <CustomSwitch name="accessOnAllJourneys" checked={accessToAllJourney} handleChange={handleChange} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <CustomPopupText text="Departments" required />
        <div style={{ margin: '12px 0px 12px 0px' }}>
          <CustomMultiSelect
            label="Select Departments"
            list={list}
            selectedValue={mainArr}
            handleFilterChange={handleMultiSelectChange}
            name="categories"
            width="100%"
            height="44px"
          />
        </div>
      </Grid>
      <Grid item xs={12}>
        <CustomPopupText text=" Expertise Level" required />
        <CustomDropDown
          width="100%"
          value={data?.expertiseLevel?.name || 'Select a value'}
          name="expertiseLevel"
          list={expList}
          handleChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomPopupText text="Certificate Background:" />
        <CustomUploadField
          type="image"
          name="certificate"
          imgSrc={certificateImg}
          handleChange={handleImageUploadNew}
          customStyles={{ height: '44px', width: '482px' }}
          handleDelete={handleDeleteImage}
          fileName={certFileName}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomPopupText text="Categories" />
        <div style={{ margin: '12px 0px 12px 0px' }}>
          <CustomGroupDropDown
            handleChange={handleGroupChange}
            value={selectedCatValues}
            width="100%"
            height="44px"
            marginBottom="20px"
            list={catList}
            name="grouped-select"
            disabled={data?.isEpg ?? false}
            groupKey="department"
            labelKey="name"
          />
        </div>
      </Grid>

      <Grid item xs={12}>
        <Grid container alignItems="center">
          <Grid item>
            <CustomPopupText text="Content Type" required />
          </Grid>
          <Grid item>
            <Grid container>
              <CustomRadioGroup
                name="type"
                value={contentType.type}
                options={CONTENT_TYPE}
                handleChange={handleContentType}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} style={[2, 3].includes(contentType.type) ? {} : { display: 'none' }}>
        <Grid container justifyContent="space-between" spacing={1}>
          <Grid item xs={6}>
            <Grid container>
              <Grid item xs={12}>
                <CustomPopupText
                  text={`Select ${CONTENT_TYPE?.find((item) => item.value === contentType.type)?.name}`}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <CustomDropDown
                  width="100%"
                  value={
                    options?.filter((option) => option.id === parseInt(contentType.selectedItem, 10))[0]?.displayName
                  }
                  name="contentType"
                  list={options}
                  handleChange={(e) =>
                    setContentType((pre) => ({
                      ...pre,
                      selectedItem: e.target.value,
                    }))
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container>
              <Grid item xs={12}>
                <CustomPopupText text="Due Date" />
              </Grid>
              <Grid item xs={12}>
                <CustomPicker
                  type="default"
                  data={contentType}
                  handleDateChange={handleDateChange}
                  customStyles={classes.publishDateField}
                  name="dueDate"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} style={{ marginTop: '10px' }}>
        <Grid container direction="row" justifyContent="space-between" alignItems="center" style={{ margin: '0px' }}>
          <Grid item>
            <CustomPopupText text="Make collection 'In-Person Class'" />
          </Grid>

          <Grid item>
            <CustomSwitch name="isEpg" checked={data?.isEpg} handleChange={handleChange} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default CollectionDetail;
